import isProd from '~/utils/isProd';

export const STEPS = [
  {
    label: 'Salesforce ID',
    title: 'Step 1: Add offer ID from Salesforce',
    helperText: 'Enter the Salesforce offer ID to start the set up flow.',
  },
  {
    label: 'Prerequisites',
    title: 'Step 2: Confirm Salesforce data is ready',
    helperText: "We're syncing the latest Salesforce data. Once complete, all items below must be met to continue.",
  },
  {
    label: 'Property',
    title: 'Step 3: Check or create property',
    helperText: 'Use an existing property, or create a new property using defaults.',
  },
  {
    label: 'Rooms',
    title: 'Step 4: Create rooms on property',
    helperText: 'Room details will be added here.',
  },
  {
    label: 'Rate plan',
    title: 'Step 5: Create Flash Rate Plans',
    helperText: 'Add, collapse, or remove rate plans as needed. At least one rate plan is required.',
  },
  {
    label: 'Room rates',
    title: 'Step 6: Apply Rate Plans to rooms',
    helperText: 'Choose which Flash rate plans to apply to each room.',
  },
  {
    label: 'Capacity',
    title: 'Step 7: Set room rate capacity',
    helperText: 'Deal options need a capacity set on their room rate before they can appear on the front end.',
  },
  {
    label: 'Taxes & fees',
    title: 'Step 8: Taxes and Fees',
    helperText: 'Taxes and fees will be selected from the country rules.',
  },
  {
    label: 'Package setup',
    title: 'Step 9: Confirm package settings',
    helperText: 'Confirm whether each package allows extra nights, and set a maximum where it does.',
  },
  {
    label: 'Submission',
    title: 'Step 10: Create the Flash offer',
    helperText: 'Review the draft below, then create the Flash offer.',
  },
];

export const CREATE_NEW_PROPERTY = 'create-new-property';
export const DEFAULT_NEW_PROPERTY_LOGO_ID = isProd() ? 'plm281bk7bzlz47qzn3r' : 'ame2pu7ycca2scvuqhqq';
export const PROPERTY_FORM_ID = 'flash-offer-property-form';
export const TAXES_FEES_FORM_ID = 'flash-offer-taxes-fees-form';
export const PACKAGE_SETUP_FORM_ID = 'flash-offer-package-setup-form';
